import { useEffect, useState, useCallback } from "react";

const KEY = "her_bookmarks_v1";

const read = () => {
    try {
        const raw = typeof window !== "undefined" ? localStorage.getItem(KEY) : null;
        if (!raw) return { episodes: [], tracks: [] };
        const parsed = JSON.parse(raw);
        return {
            episodes: Array.isArray(parsed.episodes) ? parsed.episodes : [],
            tracks: Array.isArray(parsed.tracks) ? parsed.tracks : [],
        };
    } catch {
        return { episodes: [], tracks: [] };
    }
};

const write = (val) => {
    try {
        localStorage.setItem(KEY, JSON.stringify(val));
        window.dispatchEvent(new Event("her:bookmarks-changed"));
    } catch {
        /* ignore quota errors */
    }
};

export const useBookmarks = () => {
    const [marks, setMarks] = useState(read);

    useEffect(() => {
        const refresh = () => setMarks(read());
        const onStorage = (e) => {
            if (e.key === KEY) refresh();
        };
        window.addEventListener("her:bookmarks-changed", refresh);
        window.addEventListener("storage", onStorage);
        return () => {
            window.removeEventListener("her:bookmarks-changed", refresh);
            window.removeEventListener("storage", onStorage);
        };
    }, []);

    const toggle = useCallback((kind, id) => {
        const cur = read();
        const list = cur[kind] || [];
        const next = list.includes(id) ? list.filter((x) => x !== id) : [...list, id];
        write({ ...cur, [kind]: next });
    }, []);

    const isMarked = useCallback(
        (kind, id) => (marks[kind] || []).includes(id),
        [marks]
    );

    const remove = useCallback((kind, id) => {
        const cur = read();
        write({ ...cur, [kind]: (cur[kind] || []).filter((x) => x !== id) });
    }, []);

    const total = (marks.episodes?.length || 0) + (marks.tracks?.length || 0);

    return { marks, toggle, isMarked, remove, total };
};
